var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.streamKey)?_c('StreamSetting',{attrs:{"rtmp":_vm.rtmp,"link":_vm.link,"stream-key":_vm.streamKey,"username":_vm.username,"desc":_vm.desc}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }